<template>
  <div>
    <BaseDialog
      :show="true"
      :info="dialogInfo"
      :show-modal="false"
      @cancel="handleCancel"
      @confirm="handelConfirm"
    >
      <div slot="content">
        <el-form
          ref="registerForm"
          :model="registerForm"
          :rules="registerRules"
        >
          <el-form-item prop="email" :label="$t('form.setting.account_email')">
            <TbbInput
              v-model="registerForm.email"
              :disabled="isAccess ? false : !!registerForm.email"
              :show-pas="true"
              :placeholder="'placeholder.login_username'"
            />
          </el-form-item>

          <el-form-item
            prop="code"
            class="register-code flex flex-direction-column"
            :label="$t('form.forgot.code')"
          >
            <TbbInput
              v-model="registerForm.code"
              :show-pas="true"
              :placeholder="'placeholder.verification_code'"
            />
            <el-button class="get-code-btn" type="lightblue" @click="sendCode" style="width: 112px;">
              {{ timeCount ? `${timeCount}s` : $t('button.get_code') }}
            </el-button>
          </el-form-item>

          <el-form-item prop="userName" :label="$t('form.setting.user_name')">
            <TbbInput
              v-model="registerForm.userName"
              :show-pas="true"
              :placeholder="'placeholder.please_enter'"
            />
          </el-form-item>
          <el-form-item prop="password" :label="$t('form.setting.password')">
            <TbbInput
              v-model="registerForm.password"
              :show-pas="false"
              :show-eye="true"
              :placeholder="'placeholder.login_password'"
            />
          </el-form-item>
        </el-form>
      </div>
    </BaseDialog>
  </div>
</template>

<script>
import { sendUserCode } from '@/api/user'
import {
  validateUsername,
  validatePasswordTest,
  validateCode
} from '@/utils/form/rule'

export default {
  name: 'RegisterDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    }
  },
  data() {
    let that = this
    return {
      dialogInfo: {
        title: 'dialog.register.title',
        dec: 'dialog.register.dec'
      },
      timeCount: 0,
      registerForm: {
        email: '',
        password: '',
        userName: '',
        code: ''
      },
      isAccess: false,
      registerRules: {
        email: [
          { required: true, trigger: 'blur', validator: validateUsername },
          {
            type: 'email',
            message: that.$t('rules.email_invalid'),
            trigger: 'change'
          }
        ],
        code: [{ required: true, trigger: 'blur', validator: validateCode }],

        userName: [
          {
            required: true,
            trigger: 'blur',
            message: that.$t('rules.validate_user_name')
          },
          {
            min: 1,
            max: 15,
            message: that.$t('rules.validate_user_name'),
            trigger: 'change'
          }
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePasswordTest }
        ]
      }
    }
  },
  created() {
    this.getQueryEmail()
    this.isAccess = /tbbaccess/.test(location.pathname)
    this.dialogInfo = {
       title: this.title || this.dialogInfo.title,
       dec: this.desc || this.dialogInfo.dec 
    }

    console.log(this.dialogInfo, 'this.dialogInfo')
  },
  methods: {
    getQueryEmail() {
      let query = this.$route.query
      this.registerForm.email = query.email ? query.email : ''
      console.log(this.registerForm, 'this.registerForm')
    },
    handleCancel(val) {
      this.$refs['registerForm'].resetFields()

      this.$emit('cancel', val)
    },
    handelConfirm() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          this.$store.dispatch('setDialogConfirmBtn', true)
          let formData = JSON.parse(JSON.stringify(this.registerForm))
          this.$emit('confirm', formData)
          // this.$refs['registerForm'].resetFields()
        }
      })
    },
    intervalTimer(){
      this.timeCount = 59;
      this.timer = setInterval(() => {
        this.timeCount = this.timeCount - 1

        if(this.timeCount === 0) {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    sendCode() {
      if(this.timeCount) return;
      const params = {
        email: this.registerForm.email,
        type: 1
      }
      if (params.email) {
        sendUserCode(params).then((res) => {
          if (res) {
            this.intervalTimer()
            this.$message({
              message: this.$t('message.message_send_code_success'),
              type: 'success'
            })
          }
        })
      } else {
        this.$message({
          message: this.$t('message.message_send_code_fail'),
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.register-code {
  .el-form-item__label {
    text-align: left;
  }
  .el-form-item__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tbb-input {
      width: 290px;
    }
  }
}
.get-code-btn {
  height: 50px !important;
  padding: 0px 20px;
}
</style>
